export const DISPLAY_MESSAGE_ACTION = "DISPLAY_MESSAGE";
export const CLEAR_MESSAGE_ACTION = "CLEAR_MESSAGE";

export const DRAWER_STATE_ACTION = "DRAWER_STATE";

export const CLEAR_STATUS_ACTION = "CLEAR_STATUS";
